import React, { Component, Fragment } from 'react';
import ProTypes from 'prop-types';
import { connect } from 'react-redux';
import { loginUser } from '../redux/actions/userActions';
import GoogleLogin from 'react-google-login';

class GoogleLoginButton extends Component {
  responseGoogle = (response) => {
    if(response) {
      const token = {
        token: response.tokenId,
      };
      this.props.loginUser(token, this.props.history);
      const profile = {
        fullname: response.profileObj.name,
        avatar: response.profileObj.imageUrl,
      }
      this.props.setProfile(profile)
    } else {
      const error_google_login = {
        message: 'Lỗi đăng nhập, vui lòng thử lại sau.'
      }
      this.props.setErrorLogin(error_google_login)
    }
  }

  render() {
    return (
      <Fragment>
          <GoogleLogin
            clientId="21497640688-kmco6ragpf85jctm80lhbm5ru0j7eboh.apps.googleusercontent.com"
            render={renderProps => (
              <button className="google-login" onClick={renderProps.onClick} disabled={renderProps.disabled}><i className="fab fa-google mr-10" /> Đăng nhập</button>
            )}
            onSuccess={this.responseGoogle}
            onFailure={this.responseGoogle}
            cookiePolicy={'single_host_origin'}
          />
      </Fragment>
    )
  }
}

GoogleLoginButton.propTypes = {
  loginUser:  ProTypes.func.isRequired,
}

const mapActionsToProps = {
  loginUser
}
export default connect(null, mapActionsToProps)(GoogleLoginButton);